import { Modal, Collapse } from "bootstrap";
import { IAPIResult, TextPack, CloseFormEnum, ICAMSKey, FeatureType } from "../Models/UtilityModels";
import { ModalPrompts, PredefinedModalEnum, IModalPromptRequest } from "./ModalPrompts";
import { Feature } from "ol";
import { MapLayerGroupType } from "../Models/MapConfigModels";
import { UserDefinedFields } from "../UserDefinedFields/UserDefinedFields";
import { Translations } from "../Models/StaticTranslations";
import * as toastr from "toastr";
export interface ITextPackModel { textPack: TextPack, key: string, value?: string };
export interface ITextPackResultModel { success: boolean; data: Array<ITextPackModel> };

export enum jqc {
    placeholder_for_promptModals = '#placeholder-for-promptModals'
}

declare global {
    interface Window {
        isSiteInWelsh: Function;
    }
}

export class Utilities {

    // ----------------------------------------------------------- //
    // UI Blocking
    static BlockUI = (el?: JQuery<HTMLElement>, timeout?: number, message: string = null): void => {
        // If the message is null, then create the Please Wait msg
        if (message == null) {
            message = window.isSiteInWelsh() == true ? "Arhoswch os gwelwch yn dda..." : "Please Wait...";
        }

        let options = {
            css: {
                border: 'none',
                padding: '15px',
                backgroundColor: '#000',
                '-webkit-border-radius': '10px',
                '-moz-border-radius': '10px',
                opacity: .5,
                color: '#fff'
            },
            message: message
        };

        if (timeout != null || timeout != undefined) {
            options['timeout'] = timeout;
        }

        if (el == null) {
            $.blockUI(options);
        }
        else {
            el.block(options);
        }
    }

    static UnBlockUI = (el?: JQuery<HTMLElement>): void => {
        if (el == null) {
            $.unblockUI();
        }
        else {
            el.unblock();
        }
    }

    // ----------------------------------------------------------- //
    // Get string from an eum
    static GetStringFromEnum = (enumClass, value): string => {
        for (var k in enumClass) if (enumClass[k] == value) return k;
        return null;
    }

    // ----------------------------------------------------------- //
    // Get a jQuery control
    static GetControl = (searchStr: string): JQuery<HTMLElement> => {
        let ctrl = $(searchStr);
        if (typeof ctrl[0] === "undefined" == null) {
            console.log("Utilities.GetControl: ERROR finding: " + searchStr);
        }
        return ctrl;
    }

    // ----------------------------------------------------------- //
    // Get a Bootstrap control
    static GetModal = (searchStr: string, action: ModalAction, el: JQuery<HTMLElement> = null): Modal => {
        if (el == null) el = $(searchStr);
        if (typeof el[0] === "undefined" == null) {
            console.log("Utilities.GetModal: ERROR finding: " + searchStr);
        }

        var modal = Modal.getInstance(el[0]);
        if (modal == null) {
            if (el == null || el.length ==0) return null;
            modal = new Modal(el[0], { backdrop: 'static', keyboard: false });
        }
        if (modal == null) return null;

        switch (action) {
            case ModalAction.None:
                break;
            case ModalAction.Create:
                modal.show();
                break;
            case ModalAction.Show:
                modal.show();
                break;
            case ModalAction.Hide:
                modal.hide();
                break;
        }

        return modal;
    }

    static GetCollapse = (searchStr: string, action: CollapseAction, el: JQuery<HTMLElement> = null): Collapse => {
        if (el == null) el = $(searchStr);
        if (typeof el[0] === "undefined" == null) {
            console.log("Utilities.GetCollapse: ERROR finding: " + searchStr);
        }

        var collapse = Collapse.getInstance(el[0]);
        if (collapse == null) {
            if (el == null || el.length == 0) return null;
            collapse = new Collapse(el[0], { toggle: false });
        }
        if (collapse == null) return null;

        switch (action) {
            case CollapseAction.None:
                break;
            case CollapseAction.Create:
                break;
            case CollapseAction.Show:
                collapse.show();
                break;
            case CollapseAction.Hide:
                collapse.hide();
                break;
        }

        return collapse;
    }

    // ----------------------------------------------------------- //
    // Get the contact type list and populate a dropdown, used in various places in teh code
    static CloseFormWithPrompt = (): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.UnsavedEdits }).then(r => {
                if (r.yes == true) {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            }).catch(e => { });
        });
    }

    static CloseFormWithSaveFirstPrompt = (): Promise<CloseFormEnum> => {
        return new Promise<CloseFormEnum>((resolve, reject) => {
            ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.SaveFirstAndPrompt }).then(r => {
                if (r.yes == true) {
                    resolve(CloseFormEnum.SaveAndProceed);
                }
                else {
                    resolve(CloseFormEnum.DisregardAndProceed);
                }
            }).catch(e => { });
        });
    }

    static ShowGenericYesNoPrompt = (promptData: IModalPromptRequest): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            ModalPrompts.OpenPrompt(promptData).then(r => {
                if (r.yes == true) {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            }).catch(e => { });
        });
    }

    static UpdateContactTypeDropDown = (contactEl: JQuery<HTMLElement>, contactTypeStr: string, selectContactRef: string = null): void => {
        // Remove all options
        contactEl.find('option').remove().end();

        Utilities.BlockUI(contactEl);
        let data = { contactType: contactTypeStr, skip: 0, take: 100, alsoIncludeContactRef: selectContactRef }; // This makes sure the list we get back is liomited to 100 items, and that the selected contac tis also included

        $.post('/Contacts/GetContactsByType', data,
            function (data) {
                try {
                    var dataObject: Array<any> = jQuery.parseJSON(data);

                    dataObject.forEach(i => {
                        var selected = "";
                        if (selectContactRef != null && selectContactRef == i.ContactRef) selected = "selected";
                        contactEl.append($("<option " + selected + "></option>").attr("value", i.ContactRef).text(i.ListName));
                    });
                }
                catch (err) {
                    console.log(err);
                }
                finally {
                    Utilities.UnBlockUI(contactEl);
                }
            },
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    static IsListFormPinned = (el: JQuery<HTMLElement>): Boolean => {
        var data = el.data('pinned');
        if (data == "true") return true;
        else return false;
    }

    static TogglePinListForm = (el: JQuery<HTMLElement>, forcePinOn?: Boolean): void => {
        // If pin is null, then act like a toggle
        var doPin = forcePinOn == null ? !Utilities.IsListFormPinned(el) : forcePinOn;
        var iconEl = el.find('i');

        if (doPin == true) {
            iconEl.removeClass('fa-rotate-90');
            iconEl.removeClass('far');
            iconEl.addClass('fas');
            el.data('pinned', 'true');
        }
        else {
            iconEl.addClass('fa-rotate-90');
            iconEl.removeClass('fas');
            iconEl.addClass('far');
            el.data('pinned', 'false');
        }
    }

    static GetTranslations = (textPacks: Array<ITextPackModel>): Promise<ITextPackResultModel> => {
        var url = window.G_SITEFOLDERNAME +"/Translation/GetTextTranslations";

        return new Promise<ITextPackResultModel>(
            function (resolve, reject) {
                $.ajax({
                    type: "POST",
                    contentType: "application/json; charset=utf-8",
                    url: url,
                    data: JSON.stringify(textPacks),
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                resolve({success: true, data: result.data});
                            }
                            else {
                                reject(result);
                            }
                        }
                        catch (err) {
                            console.log(err);
                            reject({success: false, data: "Error getting translations."});
                        }
                    }
                }).fail(function (xhr) {
                    reject({ success: false, data: "Error getting translations. Not authenticated." });
                });
            }
        );
    }

    static NumberWithCommas = (x: number): string => {
        try {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        catch (e) {
            console.log(e);
            return null;
        }
    }

    // ----------------------------------------------------------- //
    // MISC
    static convertFeatureToCAMSKey = (feature: Feature): ICAMSKey => {
        var key: ICAMSKey = {};
        let props = feature.getProperties();

        if (props.MaintCode != null) {
            key.featureType = FeatureType.Maint;
            key.code = props.MaintCode;
        }
        else if (props.RouteCode != null) {
            key.featureType = FeatureType.Route;
            key.code = props.RouteCode;
        }
        else if (props.InfraCode != null) {
            if (props.Historic == 1) {
                key.featureType = FeatureType.InfraHistoric;
                key.code = props.InfraCode;
            }
            else {
                key.featureType = FeatureType.Infra;
                key.code = props.InfraCode;
            }
        }
        else if (props.LandCode != null) {
            key.featureType = FeatureType.Land;
            key.code = props.LandCode;
        }
        else if (props.AnnotationGeomID != null) {
            key.featureType = FeatureType.Annotation;
            key.code = props.AnnotationGeomID;
        }
        else if (props.TROGeomID != null) {
            key.featureType = FeatureType.TRO;
            key.code = props.TROGeomID;
        }
        return key;
    }

    static convertMapLayerGroupTypeToFeatureType = (m: MapLayerGroupType): FeatureType => {
        switch (m) {
            case MapLayerGroupType.Annotation: return FeatureType.Annotation;
            case MapLayerGroupType.Infra: return FeatureType.Infra;
            case MapLayerGroupType.InfraHistoric: return FeatureType.InfraHistoric;
            case MapLayerGroupType.Land: return FeatureType.Land;
            case MapLayerGroupType.Maint: return FeatureType.Maint;
            case MapLayerGroupType.MyMaint: return FeatureType.Maint;
            case MapLayerGroupType.Route: return FeatureType.Route;
            case MapLayerGroupType.TRO: return FeatureType.TRO;
            case MapLayerGroupType.LegalFeature: return FeatureType.LegalFeature;
            case MapLayerGroupType.LegalRoute: return FeatureType.LegalEvent;
            case MapLayerGroupType.User: return null;
            default: console.log("Error convertMapLayerGroupTypeToFeatureType: " + m); return null;
        }
    }

    static convertFeatureTypeToMapLayerGroupType = (f: FeatureType): MapLayerGroupType => {
        switch (f) {
            case FeatureType.Annotation: return MapLayerGroupType.Annotation;
            case FeatureType.Infra: return MapLayerGroupType.Infra;
            case FeatureType.InfraHistoric: return MapLayerGroupType.InfraHistoric;
            case FeatureType.Land: return MapLayerGroupType.Land;
            case FeatureType.Maint: return MapLayerGroupType.Maint;
            case FeatureType.Path: return MapLayerGroupType.Route;
            case FeatureType.Route: return MapLayerGroupType.Route;
            case FeatureType.TRO: return MapLayerGroupType.TRO;
            case FeatureType.LegalEvent: return MapLayerGroupType.LegalRoute;
            case FeatureType.LegalFeature: return MapLayerGroupType.LegalFeature;
            default: console.log("Error convertFeatureTypeToMapLayerGroupType: " + f); return null;
        }
    }

    static getFeatureTypeFromFeature = (feature: Feature): FeatureType => {
        let ft: FeatureType;

        if (feature.getProperties().MaintCode != null) {
            return FeatureType.Maint;
        }
        else if (feature.getProperties().InfraCode != null) {
            if (feature.getProperties().InfraHistoric == 1) return FeatureType.InfraHistoric;
            else return FeatureType.Infra;
        }
        else if (feature.getProperties().RouteCode != null) {
            return FeatureType.Route;
        }
        else if (feature.getProperties().LandCode != null) {
            return FeatureType.Land;
        }
        else if (feature.getProperties().AnnotationGeomID != null) {
            return FeatureType.Annotation;
        }
        else if (feature.getProperties().TROGeomID != null) {
            return FeatureType.TRO;
        }
    }

    static InitFormValidation = (formEl: JQuery<HTMLElement>): void => {
        let lang = window.isSiteInWelsh() == true ? 1 : 0;
        formEl.removeData("validator");
        formEl.removeData("unobtrusiveValidation");
        formEl.find("[data-val-required]").attr("data-val-required", Translations.Lang.RequiredValidation[lang]);
        (<any>$).validator.unobtrusive.parse("form");
    }

    static CheckFormValidation = (formEl: JQuery<HTMLElement>): Boolean => {
        let form = <any>formEl;
        if (form.validate().form() == false || UserDefinedFields.ValidateUDFs(form) == false) {
            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_PleaseEnterAllValues" }]).then(m => {
                if (m.success == true) toastr.error(m.data[0].value);
                else toastr.error("Please make sure you have entered all required values.");
            });
            return false;
        }
        else return true;
    }
}

// Enum
export enum ModalAction {
    None,
    Create,
    Show,
    Hide
}

export enum CollapseAction {
    None,
    Create,
    Show,
    Hide
}




